import ServiceDetail from "@/components/ServiceDetail";
import { SERVICES_DATA } from "@/data/services";
import { GALLERY_ITEMS } from "@/data/gallery";

export default function Decking() {
    const projects = GALLERY_ITEMS.filter((g) => g.category === "decking");
    return <ServiceDetail data={SERVICES_DATA.decking} projects={projects} />;
}
